import getApi from '../../api'
import { deserializeMedicalEventResponse } from './mapper/medicalEvents.mapper'
import { ApiMedicalEventResource, MedicalEventMutationPayload } from './mapper/medicalEvents.model'

export const createMedicalEvent = (medicalEvent: MedicalEventMutationPayload) =>
  getApi()
    .post<ApiMedicalEventResource>('/medical_events', medicalEvent)
    .then(deserializeMedicalEventResponse)
